import instaclustrComponent from "./Components";
import lozad from "lozad";

const observer = lozad();

export class Component extends instaclustrComponent {
    constructor(name, node) {
        super(name, node);
    }
    init() {
        console.log(this.name);
        // OWL carousel settings
        jQuery(document).ready(function(){

            // See more carousel settings:
            // https://owlcarousel2.github.io/OwlCarousel2/docs/api-options.html
            let $carousels = jQuery(".owl-carousel");

            let cellNumber = {
                0:    { items: 1 },
                768:  { items: 1 }, // md
                992:  { items: 1 } // lg
            }
            // Number of cells
            $carousels.each(function() {
                if ($(this).hasClass('three-cell')) {
                    cellNumber = {
                        0:    { items: 1 },
                        576:  { items: 1 },
                        768:  { items: 2 },
                        992:  { items: 3 }
                    }
                }
            });

            let carouselArgs = {
                autoplay: false,
                autoplaySpeed: 800,
                autoHeight: false,
                loop: true,
                rewind: false,
                margin: 16,
                nav: true,
                dots: true,
                dotsSpeed: 400,
                navSpeed: 500,
                slideTransition: 'ease',
                lazyLoad: true,
                responsive: cellNumber
            }

            if ($carousels.length > 1) {
                $carousels.each(function() {
                    $(this).owlCarousel(carouselArgs);
                });
            } else if ($carousels.length === 1) {
                $carousels.owlCarousel(carouselArgs)
            }

            // Remove default span arrow to use our own background image with css
            $('.owl-prev span').html('');
            $('.owl-next span').html('');

        });

        // Re-observe and after owl carousel has had time to initialize
        // This allows lozad to lazyload owl-cloned carousel items
        setTimeout(function() {
            observer.observe();
        }, 3000);
    }
}